import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const PARTS_PER_STOCK_LOCATIONS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'PARTS_PER_STOCK_LOCATIONS'
);
export const PARTS_PER_STOCK_LOCATIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	PARTS_PER_STOCK_LOCATIONS_CRUD_ACTION_CONSTANTS
);
